<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">计划基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="计划编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成计划编号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写计划名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="巡检质控项目（多选）" prop="patrolProjectIdArr">
                <el-select :disabled="!editMode" v-model="form.patrolProjectIdArr" style="width: 90%" multiple collapse-tags :filter-method="getPatrolProjects" placeholder="请选择巡检质控项目" @change="patrolProjectChange">
                  <el-option v-for="item in patrolProjects" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="巡检质控科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择巡检质控科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="巡检质控人员" prop="userName">
                <el-select :disabled="!editMode" v-model="form.userName" style="width: 90%" filterable placeholder="请选择巡检质控人员" :filter-method="getUsersByDept" @change="dutyUserChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="巡检质控有效期" prop="dateRange">
                <el-date-picker :disabled="!editMode" style="width: 90%" v-model="form.dateRange" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计下次日期" prop="nextDate">
                <el-date-picker :disabled="!editMode" v-model="form.nextDate" :picker-options="{
                    disabledDate(v) {
                      return disabledDateFun(v);
                    },
                  }" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择预计下次日期" @change="nextDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="下次巡检质控人员" :prop="form.nextDate ? 'nextUserName' : ''">
                <el-select :disabled="!editMode" v-model="form.nextUserName" style="width: 90%" filterable placeholder="请选择下次巡检质控人员" :filter-method="getUsers" @change="nextUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计巡检质控费用" prop="estimateToTalAmount">
                <el-input-number disabled v-model="form.estimateToTalAmount" :min="0" :precision="4" :controls="false" placeholder="根据子表费用明细汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="实际巡检质控费用" prop="toTalAmount">
                <el-input-number disabled v-model="form.toTalAmount" :min="0" :precision="4" :controls="false" placeholder="根据已执行的巡检质控计划汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%" placeholder="系统默认为当前操作人员"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="巡检质控说明" prop="desc">
                <el-input :disabled="!editMode" v-model="form.desc" placeholder="请填写巡检质控说明" type="textarea" resize="none" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" type="textarea" resize="none" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <InvoiceEdit></InvoiceEdit>

        <AssetInfoEdit ref="AssetInfoEditRef" :data="form.details" :canEdit="editMode" :ParentForm="form" :FixedAssetParam="{ deptId: form.deptId }" @autoTotalAmount="autoTotalAmount" :isWorkOrder="true" WorkOrderAmountName="巡检质控" :showDimension="true" :assetCardMultiple="false" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前资产信息已存在，请去子表编辑！">
        </AssetInfoEdit>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetPatrolPlanById,
  SavePatrolPlan,
  RejectPatrolPlan,
  GetPatrolProjects,
  GetPatrolPlanExecuteById,
  RejectPatrolPlanExecute,
} from "@/api";
import { WhetherOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
import InvoiceEdit from "@/components/invoice-edit";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
    InvoiceEdit,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "巡检质控计划",
      form: {},
      rules: {
        name: [
          { required: true, message: "计划名称不能为空", trigger: "blur" },
        ],
        patrolProjectIdArr: [
          { required: true, message: "巡检质控项目不能为空", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "巡检质控科室不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "巡检质控人员不能为空", trigger: "blur" },
        ],
        dateRange: [
          {
            required: true,
            message: "巡检质控有效期不能为空",
            trigger: "blur",
          },
        ],
        nextUserName: [
          {
            required: true,
            message: "下次巡检质控人员不能为空",
            trigger: "blur",
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: null,
      patrolProjects: [],
      WhetherOptions: WhetherOptions,
      pickerOptions: {
        disabledDate (v) {
          return (
            v.getTime() < new Date(new Date() - 1000 * 60 * 60 * 24).getTime()
          );
        },
      },
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.category) {
        this.category = query.category;
      }
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      switch (this.category) {
        case "1":
        case "2":
          this.reject = RejectPatrolPlan;
          GetPatrolPlanById({ id }).then((res) => {
            // this.resetForm()
            this.form = res.returnData;
            this.form.dateRange = [this.form.date, this.form.endDate];
            if (!this.form.details) {
              this.form.details = [];
            }
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });

            if (this.form.patrolProjectInfos) {
              this.form.patrolProjectIds = this.form.patrolProjectInfos
                .map((item) => item.id)
                .join(";");
              this.form.patrolProjectIdArr = this.form.patrolProjectInfos.map(
                (item) => item.id
              );
            }
            this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
            this.initWorkFlowProperty(this.form);
          });
          break;
        case "3":
          this.reject = RejectPatrolPlanExecute;
          GetPatrolPlanExecuteById({ id }).then((res) => {
            // this.resetForm()
            this.form = res.returnData;
            this.form.dateRange = [this.form.date, this.form.endDate];
            if (!this.form.details) {
              this.form.details = [];
            }
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });

            if (this.form.patrolProjectInfos) {
              this.form.patrolProjectIds = this.form.patrolProjectInfos
                .map((item) => item.id)
                .join(";");
              this.form.patrolProjectIdArr = this.form.patrolProjectInfos.map(
                (item) => item.id
              );
            }

            this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
            this.initWorkFlowProperty(this.form);
          });
          break;
      }
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        name: "",
        patrolProjectIds: "",
        patrolProjectIdArr: [],
        patrolProjectNameArr: [],
        patrolProjectInfos: [],
        deptName: "",
        deptId: "",
        userName: "",
        userId: "",
        dateRange: [
          this.parseTime(new Date(), "{y}-{m}-{d}"),
          this.parseTime(new Date(), "{y}-{m}-{d}"),
        ],
        nextDate: "",
        nextUserName: "",
        estimateToTalAmount: 0,
        toTalAmount: 0,
        createdUser: this.userInfo.id,
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
        desc: "",
        remark: "",
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
      this.dateChange(this.form.dateRange);
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SavePatrolPlan(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.backWarehouseId = item.id;
        this.form.backWarehouseManagerId = item.managerId;
        this.form.backWarehouseManagerName = item.managerName;
      }
    },
    autoTotalAmount (e) {
      this.form.details = e;
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.fees * 1;
        e[index].unBillNumber = element.number;
        e[index].unBillAmount = element.fees;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.estimateToTalAmount = totalAmount;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    /**
     * 保养模板选择
     */
    patrolProjectChange (val) {
      if (val && val.length > 0) {
        let isAdd = false;
        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.form.patrolProjectInfos.find((e) => e.id == val[i]);
          if (item == null) {
            isAdd = true;
            let obj = this.patrolProjects.find((e) => e.id == val[i]);
            if (obj) {
              this.form.patrolProjectInfos.push(obj);
            }
            break;
          }
        }
        // 删除
        if (!isAdd) {
          this.form.patrolProjectInfos = this.form.patrolProjectInfos.filter(
            (i) => val.indexOf(i.id) != -1
          );
        }
        this.form.patrolProjectIds = this.form.patrolProjectInfos
          .map((item) => item.id)
          .join(";");
      } else {
        this.form.patrolProjectIds = "";
        this.form.patrolProjectInfos = [];
      }
    },
    dateChange (val) {
      if (val) {
        this.$set(this.form, "date", val[0]);
        this.$set(this.form, "endDate", val[1]);
        if (
          new Date(val[1]).getTime() >= new Date(this.form.nextDate).getTime()
        ) {
          this.$set(this.form, "nextDate", null);
        }
      } else {
        this.$set(this.form, "date", null);
        this.$set(this.form, "endDate", null);
      }
    },
    deptChange (val) {
      this.$set(this.form, "deptId", val);
      this.$set(this.form, "userId", null);
      this.$set(this.form, "userName", null);
      var item = this.STATIC_Depts.find((t) => t.id == val);
      if (item) {
        this.$set(this.form, "userId", item.leader);
        this.$set(this.form, "userName", item.leaderName);
      }
      this.getUsersByDept();
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    nextUserChange (val) {
      this.form.nextUserId = val;
    },
    /**
     * 下次巡检日期选择
     */
    nextDateChange (val) {
      if (val) {
        this.$set(this.form, "nextUserName", this.userInfo.name);
        this.$set(this.form, "nextUserId", this.userInfo.id);
      } else {
        this.$set(this.form, "nextUserName", null);
        this.$set(this.form, "nextUserId", null);
      }
    },
    getPatrolProjects (keyWord) {
      let query = { ...this.defaultAllQueryParams };
      query.keyWord = keyWord;
      GetPatrolProjects(query).then((res) => {
        this.patrolProjects = res.returnData.data;
      });
    },
    getUsersByDept (keyWord) {
      return this.getDeptUsers(this.form.deptId, keyWord);
    },
    disabledDateFun (v) {
      return v.getTime() <= new Date(this.form.endDate).getTime();
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getDepts();
    this.getPatrolProjects();
    this.getWarehouses();
    this.getUsers();
    this.$refs.AssetInfoEditRef.getFixedAssetList();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
/deep/.el-tag {
  max-width: 120px;
}
</style>
